import RocketSvg from '@/../img/404.svg';
import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { usePlaceSpecificUrlFactory } from '../../utils/place-detection';

const Wrapper = styled.div`
  display: flex;
  max-width: 1300px;
  margin-left: auto;
  margin-right: auto;
`;

const TextWrapper = styled.div`
  width: 50%;
`;

const ImageWrapper = styled.div`
  width: 50%;
`;

const TitleWrapper = styled.div`
  font-size: 32px;
  font-weight: 600;
  margin-bottom: 30px;
`;

const ParagraphWrapper = styled.div`
  font-size: 14px;
  font-weight: bold;
  margin-bottom: 30px;
`;

const LinksWrapper = styled.div`
  font-size: 16px;
  font-weight: 600;
`;

export function PropertyNotFound() {
  const getPlaceSpecificUrl = usePlaceSpecificUrlFactory();
  return (
    <Wrapper>
      <TextWrapper>
        <TitleWrapper>
          Looks like the page you’re trying to visit doesn’t exist.
        </TitleWrapper>
        <ParagraphWrapper>
          {/* commenting the text below because the help page is not ready */}
          {/* You may go back to previous page or visit our Help Center. */}
        </ParagraphWrapper>
        <LinksWrapper>
          <Link
            data-cy="property-not-found-home-link"
            to={getPlaceSpecificUrl('/home')}
            css="color: #101938; margin-right: 15px;"
          >
            Map
          </Link>
          <Link
            data-cy="property-not-found-list-link"
            to={getPlaceSpecificUrl('/list')}
            css="color: #101938; margin-right: 15px;"
          >
            List
          </Link>
          <Link
            data-cy="property-not-found-dashboard-link"
            to={getPlaceSpecificUrl('/dashboard')}
            css="color: #101938;"
          >
            Dashboard
          </Link>
        </LinksWrapper>
      </TextWrapper>
      <ImageWrapper>
        <RocketSvg />
      </ImageWrapper>
    </Wrapper>
  );
}
